module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMyIiBoZWlnaHQ9IjIwMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIGZpbGw9Im5vbmUiPjxwYXRoIGZpbGw9IiM0REJBODciIGQ9Ik0xNDIuNzkgMEwxMTYgNDYuNDIgODkuMjExIDBIMGwxMTYgMjAxTDIzMiAweiIvPjxwYXRoIGZpbGw9IiM0MzU0NjYiIGQ9Ik0xNDIuMjUgMEwxMTUuNSA0Ni41NzMgODguNzUgMEg0Nmw2OS41IDEyMUwxODUgMHoiLz48L2c+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/vue.svg
// module id = 560
// module chunks = 35783957827783